import React from 'react';
import { HiStar } from 'react-icons/hi2';
import { useScrollReveal } from '../utils/useScrollReveal';
import './Reviews.css';

const REVIEWS = [
  {
    name: 'Sarah Chen',
    role: 'Indie iOS Developer',
    app: 'FitTrack Pro',
    avatar: 'SC',
    color: '#0071e3',
    rating: 5,
    text: 'I spent 6 months building my app and 5 minutes on screenshots. Conversion was 8%. StoreShot redesigned everything — metadata included — and I hit 50% conversion the next week. I should have done this from day one.',
  },
  {
    name: 'Marcus Johnson',
    role: 'CEO, AppVentures',
    app: 'MoneyWise',
    avatar: 'MJ',
    color: '#34c759',
    rating: 5,
    text: 'We had 3 engineers and zero marketing people. Our app was solid but downloads were flatline. StoreShot rewrote our metadata and rebuilt our screenshots — went from 200 to 1,400 downloads/week. Same app, zero code changes.',
  },
  {
    name: 'Elena Rodriguez',
    role: 'Product Manager',
    app: 'FoodDash',
    avatar: 'ER',
    color: '#ff9f0a',
    rating: 5,
    text: 'Our devs kept saying "the app speaks for itself." It didn\'t. StoreShot turned our boring Xcode simulator screenshots into something that actually sells. Conversion rate jumped from 12% to 41%. Delivered in under 24 hours.',
  },
  {
    name: 'David Park',
    role: 'Founder, PixelApps',
    app: 'WeatherNow',
    avatar: 'DP',
    color: '#af52de',
    rating: 5,
    text: 'I\'m a backend engineer. I know nothing about design or marketing. StoreShot handled screenshots AND metadata — keywords, description, the whole thing. My conversion went from "why is nobody downloading this" to 67% overnight.',
  },
  {
    name: 'Lisa Thompson',
    role: 'Solo Flutter Developer',
    app: 'ConnectHub',
    avatar: 'LT',
    color: '#ff3b30',
    rating: 5,
    text: 'I used to think screenshots don\'t matter. Then I saw my competitor — worse app, better screenshots — ranking above me. StoreShot fixed that in 48 hours. Now I outrank them. Should have spent money here instead of another framework.',
  },
  {
    name: 'James Wright',
    role: 'Solo Developer',
    app: 'NoteFlow',
    avatar: 'JW',
    color: '#5856d6',
    rating: 5,
    text: 'Best developers aren\'t the best marketers — that was me. I was embarrassed by my store listing but didn\'t know how to fix it. StoreShot gave me a listing that looks like a top-funded startup made it. Downloads tripled.',
  },
];

function ReviewCard({ review }) {
  return (
    <div className="review-card">
      <div className="review-card__stars">
        {[...Array(review.rating)].map((_, i) => (
          <HiStar key={i} />
        ))}
      </div>
      <p className="review-card__text">"{review.text}"</p>
      <div className="review-card__author">
        <div className="review-card__avatar" style={{ background: review.color }}>
          {review.avatar}
        </div>
        <div className="review-card__info">
          <strong className="review-card__name">{review.name}</strong>
          <span className="review-card__role">{review.role}</span>
          <span className="review-card__app">{review.app}</span>
        </div>
      </div>
    </div>
  );
}

export default function Reviews() {
  const [headerRef, headerVisible] = useScrollReveal();
  const [gridRef, gridVisible] = useScrollReveal();

  return (
    <section className="reviews section" id="reviews">
      <div className="container">
        <div ref={headerRef} className={`reviews__header reveal ${headerVisible ? 'is-revealed' : ''}`}>
          <span className="section-label">Reviews</span>
          <h2 className="section-title">Loved by App Developers</h2>
          <p className="section-subtitle">
            Real results from real apps.
          </p>
        </div>

        <div className="reviews__stats">
          <div className="reviews__stat-item">
            <div className="reviews__stat-stars">
              {[...Array(5)].map((_, i) => <HiStar key={i} />)}
            </div>
            <strong>4.9/5</strong>
            <span>from 312 reviews</span>
          </div>
        </div>

        <div ref={gridRef} className={`reviews__grid reveal-stagger ${gridVisible ? 'is-revealed' : ''}`}>
          {REVIEWS.map((review, i) => (
            <ReviewCard key={i} review={review} />
          ))}
        </div>
      </div>
    </section>
  );
}
